"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var material_1 = require("@mui/material");
var colors_1 = require("../ThemeProvider/colors");
var styles_1 = require("@mui/material/styles");
var Connector = (0, styled_1.default)(material_1.StepConnector)(function () {
    var theme = (0, styles_1.useTheme)();
    return {
        ' &.MuiStepConnector-alternativeLabel ': {
            top: 20,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        '& .MuiStepConnector-line': {
            borderColor: colors_1.tannerGray[300],
            borderTopWidth: 2,
            borderRadius: 3,
            margin: '0px 12px',
        },
        '&.Mui-active': {
            '& .MuiStepConnector-line': {
                borderColor: theme.palette.primary.main,
            },
        },
        '&.Mui-completed': {
            '& .MuiStepConnector-line': {
                borderColor: theme.palette.primary.main,
            },
        },
        '@media (max-width: 480px)': {
            '&.MuiStepConnector-alternativeLabel': {
                top: 12,
                left: 'calc(-50% - 3px)',
                right: 'calc(50% - 3px)',
            },
            '&.MuiStepConnector-line': {
                borderColor: colors_1.tannerGray[200],
            },
        },
    };
});
exports.default = Connector;
//# sourceMappingURL=styles.js.map